// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3yLkk","title":"Header_title__OjKVW","left":"Header_left__1Fzdl","clinicName":"Header_clinicName__1ig7R"};